import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_VS,
    useChartsData
} from '../../../../Common/hooks/useChartsData';

export const PreviousPregnanciesChartsDataContext = createContext();

const PreviousPregnanciesChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_VS.PREVIOUS_PREGNANCIES_LIVE_BIRTHS,
            url: 'governanceroom/dashboard/vitalstatistics/live-births/previous-pregnancies'
        },
        {
            data_inicio: filters.data_inicio,
            data_fim: filters.data_fim,
            location: filters.unidade.value,
            city: filters.cidade?.value,
        }
    );


    const chartData = data
        ? {
              indicators: {
                  liveBirths: data?.indicators?.liveBirths ?? 0,
                  deathBirths: data?.indicators?.deathBirths ?? 0,
                  abotantions: data?.indicators?.abotantions ?? 0,
                  normalBirths: data?.indicators?.normalBirths ?? 0,
                  cesareanBirths: data?.indicators?.cesareanBirths ?? 0
              },
              previousBirthTypes: data?.previousBirthTypes ?? [],
              previousPregnanciesQuantityLiveBirths: data?.previousPregnanciesQuantityLiveBirths ?? [],
              previousPregnanciesQuantityDeathBirths: data?.previousPregnanciesQuantityDeathBirths ?? [],
              previousPregnancies: data?.previousPregnancies ?? []
          }
        : {
              indicators: {
                  liveBirths: 0,
                  deathBirths: 0,
                  abotantions: 0,
                  normalBirths: 0,
                  cesareanBirths: 0
              },
              previousBirthTypes: [],
              previousPregnanciesQuantityLiveBirths: [],
              previousPregnanciesQuantityDeathBirths: [],
              previousPregnancies: []
          };

    return (
        <PreviousPregnanciesChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </PreviousPregnanciesChartsDataContext.Provider>
    );
};

export default PreviousPregnanciesChartsDataProvider;
